import STYLES from './ReviewParagraphs.module.scss';

import FlexibleText from '@hotels-hotel-detail/ui/FlexibleText';

type Props = {
  review?: string;
  limit?: number;
  className?: string;
};

const ReviewParagraphs = ({ className, limit, review }: Props) => {
  if (!review) {
    return null;
  }

  const wrappedReview = review
    .split('\n')
    .filter((item) => !!item.trim())
    .reduce(
      (all, cur: string) => (all ? all.concat('<br />', cur) : all.concat(cur)),
      '',
    );

  if (limit) {
    return (
      <FlexibleText
        content={wrappedReview}
        className={className}
        limit={limit}
      />
    );
  }

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: wrappedReview,
      }}
      className={STYLES.ReviewParagraphs__text}
    />
  );
};

export default ReviewParagraphs;
